(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-transfers"]) return;
  try {
    
  if (!customElements.get('native-transfer-order')) {
    customElements.define('native-transfer-order', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.widthInput = this.querySelector('#NativeWidth');
        this.heightInput = this.querySelector('#NativeHeight');
        this.quantityInput = this.querySelector('#NativeQuantity');
        this.fileInput = this.querySelector('#NativeArtwork');
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent).filter(v => /^\d+-\d+ sq in$/.test(v.title));
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
        this.ratio = 1;
        this.fileValid = false;
        this.querySelectorAll('[data-size]').forEach(button => button.addEventListener('click', () => {
          const [w,h] = button.dataset.size.split('x').map(Number);
          this.widthInput.value = w;
          this.heightInput.value = h;
          this.ratio = w / h;
          this.update();
        }));
        [this.widthInput,this.heightInput].forEach(input => input.addEventListener('input', () => {
          if (this.querySelector('[data-lock]').checked && this.ratio > 0) {
            if (input === this.widthInput) this.heightInput.value = Math.round(Number(input.value) / this.ratio * 100) / 100;
            else this.widthInput.value = Math.round(Number(input.value) * this.ratio * 100) / 100;
          } else this.ratio = Number(this.widthInput.value) / Number(this.heightInput.value);
          this.update();
        }));
        this.quantityInput.addEventListener('input', () => this.update());
        this.fileInput.addEventListener('change', () => this.loadFile());
        this.querySelectorAll('[data-bg]').forEach(button => button.addEventListener('click', () => {
          const preview = this.querySelector('[data-preview]');
          preview.style.backgroundImage = button.dataset.bg === 'checker' ? '' : 'none';
          preview.style.backgroundColor = button.dataset.bg === 'checker' ? '' : button.dataset.bg;
          this.querySelectorAll('[data-bg]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        }));
        this.form.addEventListener('submit', event => {
          this.update();
          if (!this.fileValid || !this.currentVariant || !this.form.checkValidity()) { event.preventDefault(); this.form.reportValidity(); return; }
          const button = this.querySelector('[data-submit]');
          button.disabled = true;
          button.textContent = this.messages.uploading;
        });
        this.update();
      }
      loadFile() {
        const file = this.fileInput.files[0];
        const image = this.querySelector('[data-preview-image]');
        const empty = this.querySelector('[data-empty]');
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        image.hidden = true;
        empty.hidden = false;
        this.fileValid = Boolean(file && /\.(png|jpe?g|webp|pdf)$/i.test(file.name) && file.size > 0 && file.size <= 20 * 1024 * 1024);
        this.fileInput.setCustomValidity(file && !this.fileValid ? this.messages.fileError : '');
        this.querySelector('[data-file-status]').textContent = file ? file.name : '';
        if (!this.fileValid) { this.update(); return; }
        if (/\.pdf$/i.test(file.name)) { this.querySelector('[data-file-status]').textContent = file.name + ' — ' + this.messages.pdfPreview; this.update(); return; }
        this.objectUrl = URL.createObjectURL(file);
        image.onload = () => {
          image.hidden = false;
          empty.hidden = true;
          this.ratio = image.naturalWidth / image.naturalHeight;
          const w = Math.min(10, 24 * this.ratio);
          this.widthInput.value = Math.max(1,Math.round(w * 100) / 100);
          this.heightInput.value = Math.max(1,Math.round(w / this.ratio * 100) / 100);
          this.update();
        };
        image.onerror = () => { this.fileValid = false; this.fileInput.setCustomValidity(this.messages.fileError); this.update(); };
        image.src = this.objectUrl;
        this.update();
      }
      update() {
        const w = Number(this.widthInput.value), h = Number(this.heightInput.value), q = Number(this.quantityInput.value);
        const area = Math.ceil(w * h - 0.000001);
        const validDimensions = w >= 1 && w <= 22 && h >= 1 && h <= 24 && q >= 1 && q <= 10000 && Number.isInteger(q);
        this.currentVariant = validDimensions ? this.variants.find(v => { const [min,max] = v.title.match(/\d+/g).map(Number); return area >= min && area <= max; }) : null;
        this.querySelector('[data-variant]').value = this.currentVariant?.id || '';
        this.querySelector('[data-unit]').textContent = this.currentVariant ? this.format.format(this.currentVariant.price / 100) : '—';
        this.querySelector('[data-subtotal]').textContent = this.currentVariant ? this.format.format(this.currentVariant.price * q / 100) : '—';
        const totalQty = q + Number(this.dataset.cartQuantity || 0);
        const activeTier = totalQty >= 250 ? 250 : totalQty >= 100 ? 100 : totalQty >= 50 ? 50 : totalQty >= 15 ? 15 : 0;
        this.querySelectorAll('[data-tier]').forEach(row => {
          const threshold = Number(row.dataset.tier);
          const percent = threshold === 250 ? .5 : threshold === 100 ? .4 : threshold === 50 ? .3 : threshold === 15 ? .2 : 0;
          const price = this.currentVariant ? this.currentVariant.price - Math.floor(this.currentVariant.price * percent + .000001) : null;
          row.querySelector('[data-tier-price]').textContent = price !== null ? this.format.format(price / 100) : '—';
          row.toggleAttribute('data-active', threshold === activeTier);
        });
        this.querySelectorAll('[data-size]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.size === w + 'x' + h)));
        const error = this.querySelector('[data-error]');
        error.hidden = Boolean(this.currentVariant) && (!this.fileInput.files.length || this.fileValid);
        error.textContent = !this.currentVariant ? this.messages.dimensionsError : this.messages.fileError;
        this.querySelector('[data-submit]').disabled = !this.currentVariant || !this.fileValid;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-press-artwork"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-pp-art-launch]');
  if (!button) return;
  const trigger = document.getElementById('gs-builder-btn');
  if (trigger) trigger.click();
  else {
    const product = document.querySelector('[id^="MainProduct-"]');
    if (product) product.scrollIntoView({behavior:'smooth',block:'start'});
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-press-header"]) return;
  try {
    
document.addEventListener('toggle', function(event) {
  const menu = event.target;
  if (!menu.matches('.pp-mega-item') || !menu.open) return;
  document.querySelectorAll('.pp-mega-item[open]').forEach(function(other) {
    if (other !== menu) other.open = false;
  });
}, true);
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.pp-mega-item[open]').forEach(function(menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
document.addEventListener('click', function(event) {
  if (event.target.closest('.pp-head-nav')) return;
  document.querySelectorAll('.pp-mega-item[open]').forEach(function(menu) { menu.open = false; });
});

function ppInitSearch(){
  document.querySelectorAll('[data-pp-search]').forEach(function(wrap){
    if(wrap.dataset.ppSearchReady)return;
    wrap.dataset.ppSearchReady='true';
    const input=wrap.querySelector('input[type=search]');
    const popup=wrap.querySelector('[data-pp-search-popup]');
    const results=wrap.querySelector('[data-pp-search-results]');
    const status=wrap.querySelector('[data-pp-search-status]');
    let timer,controller,active=-1;
    const options=function(){return Array.from(results.querySelectorAll('[role=option]'));};
    const close=function(){popup.hidden=true;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');active=-1;};
    const select=function(index){
      const list=options();if(!list.length)return;
      active=(index+list.length)%list.length;
      list.forEach(function(item,i){item.setAttribute('aria-selected',String(i===active));});
      input.setAttribute('aria-activedescendant',list[active].id);
      list[active].scrollIntoView({block:'nearest'});
    };
    input.addEventListener('input',function(){
      clearTimeout(timer);if(controller)controller.abort();close();
      const query=input.value.trim();
      if(query.length<2){results.replaceChildren();status.textContent='';return;}
      timer=setTimeout(async function(){
        controller=new AbortController();status.textContent=wrap.dataset.searchLoading;
        const url=new URL(wrap.dataset.searchUrl,window.location.origin);
        url.searchParams.set('q',query);
        url.searchParams.set('resources[type]','product,page');
        url.searchParams.set('resources[limit]','6');
        url.searchParams.set('section_id','prime-press-search');
        try{
          const response=await fetch(url.toString(),{signal:controller.signal});
          if(!response.ok)throw new Error('Search unavailable');
          const html=await response.text();
          if(input.value.trim()!==query||document.activeElement!==input)return;
          const parsed=new DOMParser().parseFromString(html,'text/html');
          const content=parsed.querySelector('[data-pp-search-content]');
          if(!content){close();return;}
          results.replaceChildren(content);
          options().forEach(function(item,i){item.id='pp-search-option-'+i;item.setAttribute('aria-selected','false');});
          popup.hidden=false;input.setAttribute('aria-expanded','true');
          status.textContent=wrap.dataset.searchAvailable;
        }catch(error){if(error.name!=='AbortError'){status.textContent='';close();}}
      },250);
    });
    input.addEventListener('keydown',function(event){
      if(event.key==='Escape'){close();return;}
      if(popup.hidden)return;
      if(event.key==='ArrowDown'){event.preventDefault();select(active+1);}
      else if(event.key==='ArrowUp'){event.preventDefault();select(active<0?options().length-1:active-1);}
      else if(event.key==='Enter'&&active>=0){event.preventDefault();options()[active].click();}
    });
    wrap.addEventListener('focusout',function(event){if(!wrap.contains(event.relatedTarget))close();});
    document.addEventListener('click',function(event){if(!wrap.contains(event.target))close();});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ppInitSearch);else ppInitSearch();
document.addEventListener('shopify:section:load',ppInitSearch);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-press-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){
  const finder=event.target.closest('[data-pp-finder]');
  if(!finder||event.target.type!=='radio')return;
  finder.querySelectorAll('[data-pp-result]').forEach(function(result){result.hidden=result.dataset.ppResult!==event.target.value;});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-press-quote"] && !Shopify.designMode) return;
  try {
    
function ppQuotePrefill(){
  const form=document.getElementById('PrimePressQuote');
  if(!form)return;
  const params=new URLSearchParams(window.location.search);
  [['service','[data-ppq-service]'],['brand','[data-ppq-brand]']].forEach(function(pair){
    const field=form.querySelector(pair[1]);
    const value=params.get(pair[0]);
    if(!field||!value||field.value)return;
    if(Array.from(field.options).some(function(option){return option.value===value;}))field.value=value;
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ppQuotePrefill);else ppQuotePrefill();
document.addEventListener('shopify:section:load',ppQuotePrefill);

  } catch(e) { console.error(e); }
})();
})();
